export default __webpack_public_path__ + "static/media/dental-care (3)1.6b637843.png";